import { Component } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { EncdecriptService } from '../services/encdecrypt.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent {

  users: any[] = [];
  roles: any[] = [];
  departments: any[] = [];
  selectedTab = 'addUser'; // This variable controls which tab is active
  submitted = false;
  userForm: any;

  //
  isEditMode: boolean = false;
  editUserId: number | null = null;

  constructor(private fb: FormBuilder, private service: DigisubservicesService, public decryptService: EncdecriptService) {
    this.userForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)
      ]],
      mobile: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]],
      role: ['', Validators.required],
      department: [[], Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadDepartmentsData();
    this.loadRolesData();
    this.loadUsersData();
  }

  selectedDepartments = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'dep_id',
    textField: 'dep_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  selectTab(tab: string) {
    this.selectedTab = tab;
  }

  loadUsersData() {
    debugger
    const roleFromSession = sessionStorage.getItem("role");
    const deptFromSession = sessionStorage.getItem("dept");

    this.service.getUsersData().subscribe({
      next: (data) => {
        const secretKey = '123456$#@$^@1ERF';

        // Decrypt passwords
        const decryptedUsers = data.map(user => {
          user.password = this.decryptService.get(secretKey, user.password);
          return user;
        });

        if (roleFromSession === '1') {
          // Admin: show all users
          this.users = decryptedUsers;
        } else if (roleFromSession === '2') {
          // Normal user: filter users by matching department(s)

          const sessionDeptIds = deptFromSession
            ? deptFromSession.split(',').map(id => id.trim())
            : [];

          this.users = decryptedUsers.filter(user => {
            const userDeptIds = user.dep_id
              ? String(user.dep_id).split(',').map(id => id.trim())
              : [];

            // Check if any user dep_id exists in sessionDeptIds
            return userDeptIds.some(id => sessionDeptIds.includes(id));
          });
        } else {
          // Unknown role: show none
          this.users = [];
        }
      },
      error: (err) => {
        console.error('Error loading users:', err);
      }
    });
  }

  updateUser(user: any): void {
    this.userForm.patchValue({
      username: user.name,
      password: user.password,
      mobile: user.mobile,
      role: +user.role_id
    });

    // Step 1: Resolve department IDs
    let userDeptIds: number[] = [];

    if (user.dep_id) {
      // dep_id is a CSV string like "1,2"
      userDeptIds = typeof user.dep_id === 'string'
        ? user.dep_id.split(',').map((id: string) => +id.trim())
        : Array.isArray(user.dep_id)
          ? user.dep_id
          : [];
    } else if (user.department) {
      // If dep_id is null, fallback to department names
      const deptNames = user.department.split(',').map((name: string) => name.trim());
      userDeptIds = this.departments
        .filter(dept => deptNames.includes(dept.dep_name))
        .map(dept => dept.dep_id);
    }

    // Step 2: Preselect departments in multiselect
    this.selectedDepartments = this.departments.filter(dept =>
      userDeptIds.includes(dept.dep_id)
    );

    // Step 3: Set the value into reactive form
    this.userForm.get('department')?.setValue(this.selectedDepartments);

    // Set edit mode
    this.isEditMode = true;
    this.editUserId = +user.id;
    this.selectedTab = 'addUser';
  }


  deleteUser(id: number) {
    const confirmed = confirm('Are you sure you want to delete this user?');

    if (!confirmed) {
      return;
    }

    this.service.deleteUser(id).subscribe({
      next: (data: any) => {
        if (data.success) {
          alert(data.message); // "User Deleted Successfully!!!"
          this.loadUsersData(); // Refresh the user list
        } else {
          alert('Failed to delete user.');
        }
      },
      error: (err) => {
        console.error('Error deleting user:', err);
        alert('An error occurred while deleting the user.');
      }
    });
  }

  loadDepartmentsData() {
    const roleFromSession = sessionStorage.getItem("role");
    const deptFromSession = sessionStorage.getItem("dept");

    this.service.getdept().subscribe({
      next: (data) => {
        console.log('Departments:', data);

        debugger

        if (roleFromSession === '1') {
          // Admin role: show all departments
          this.departments = data;
        } else if (roleFromSession === '2') {
          const allowedDepts = deptFromSession.split(',').map(id => id.trim()); // ["2", "3", "4", "5"]

          this.departments = data.filter(dept =>
            allowedDepts.includes(String(dept.dep_id))
          );
        }
        else {
          // Fallback: show none or handle differently
          this.departments = [];
        }
      },
      error: (err) => {
        console.error('Error loading departments:', err);
      }
    });
  }

  loadRolesData() {
    const roleFromSession = sessionStorage.getItem("role");

    this.service.getRolesData().subscribe({
      next: (data) => {
        console.log('Roles:', data);

        if (roleFromSession === '1') {
          // Role 1: Show all roles
          this.roles = data;
        } else if (roleFromSession === '2') {
          // Role 2: Show only the 'User' role
          this.roles = data.filter(role => role.name === 'User');
        } else {
          // Default: show nothing or fallback logic
          this.roles = [];
        }
      },
      error: (err) => {
        console.error('Error loading roles:', err);
      }
    });
  }

  // addUser() {
  //   this.submitted = true;

  //   if (this.userForm.invalid) return;

  //   const loginData = { ...this.userForm.value };
  //   const secretKey = '123456$#@$^@1ERF';

  //   // Encrypt entered password
  //   loginData.password = this.decryptService.set(secretKey, loginData.password);

  //   this.service.addNewUser(loginData)
  //     .subscribe({
  //       next: (res: any) => {
  //         if (res.status === 'success') {
  //           alert(res.message);
  //           this.userForm.reset();
  //         } else {
  //           alert('Error: ' + res.message);
  //         }
  //       },
  //       error: (err) => {
  //         console.error(err);
  //         alert('Something went wrong!');
  //       }
  //     });
  // }

  onSubmit() {
    this.submitted = true;

    if (this.userForm.invalid) return;

    const formData = { ...this.userForm.value };
    const secretKey = '123456$#@$^@1ERF';

    // Encrypt the password before sending
    formData.password = this.decryptService.set(secretKey, formData.password);

    if (this.isEditMode && this.editUserId !== null) {

      formData.id = this.editUserId;

      // UPDATE USER
      this.service.updateUser(formData).subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            alert('User updated successfully.');
            this.resetForm();
            this.loadUsersData(); // Refresh the user list
            this.selectedTab = 'userList'; // Optional: switch tab
          } else {
            alert('Error: ' + res.message);
          }
        },
        error: (err) => {
          console.error('Update failed:', err);
          alert('Something went wrong while updating!');
        }
      });
    } else {
      debugger
      // ADD NEW USER
      this.service.addNewUser(formData).subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            alert(res.message || 'User added successfully.');
            this.resetForm();
            this.loadUsersData(); // Refresh the user list
          } else {
            alert('Error: ' + res.message);
          }
        },
        error: (err) => {
          console.error('Add failed:', err);
          alert('Something went wrong while adding!');
        }
      });
    }
  }

  resetForm() {
    this.userForm.reset();
    this.submitted = false;
    this.isEditMode = false;
    this.editUserId = null;
  }

}